import { render, staticRenderFns } from "./TrendingFollowing.vue?vue&type=template&id=ce96ebde&"
import script from "./TrendingFollowing.vue?vue&type=script&lang=js&"
export * from "./TrendingFollowing.vue?vue&type=script&lang=js&"
import style0 from "./TrendingFollowing.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports